'use client';

import { useTranslations } from 'next-intl';
import WarningIcon from 'public/images/Icons/attention-warning.svg';

import s from './index.module.scss';

import { Image } from '#/components/custom-image-loader';

const MCP_INSTALL_DOC_URL =
  'https://business-api.tiktok.com/portal/docs/how-to-connect-to-tiktok-for-business-mcp-server/v1.3';

type McpInstallWarningBannerProps = {
  onDismiss: () => void;
  variant: 'hub' | 'overlay';
};

export function McpInstallWarningBanner({ onDismiss, variant }: McpInstallWarningBannerProps) {
  const t = useTranslations();
  const variantClassName = variant === 'hub' ? s.mcpWarningBannerHub : s.mcpWarningBannerOverlay;

  return (
    <section className={`${s.mcpWarningBanner} ${variantClassName}`} role='note'>
      <div className={s.mcpWarningBannerIconColumn}>
        <Image
          alt=''
          className={s.mcpWarningBannerIcon}
          height={20}
          src={WarningIcon}
          width={20}
          aria-hidden
        />
      </div>

      <div className={s.mcpWarningBannerContent}>
        <p className={s.mcpWarningBannerTitle}>{t('skills_mcp_banner_title')}</p>
        <p className={s.mcpWarningBannerDescription}>{t('skills_mcp_banner_description')}</p>
        <a
          className={s.mcpWarningBannerInstall}
          href={MCP_INSTALL_DOC_URL}
          rel='noreferrer'
          target='_blank'
        >
          {t('skills_mcp_banner_install')}
        </a>
      </div>

      <button
        aria-label={t('skills_mcp_banner_close')}
        className={s.mcpWarningBannerClose}
        type='button'
        onClick={onDismiss}
      >
        <svg fill='none' height='16' viewBox='0 0 16 16' width='16'>
          <path
            d='M3.75781 3.75708L12.2431 12.2424'
            stroke='currentColor'
            strokeLinecap='round'
            strokeWidth='1.25'
          />
          <path
            d='M12.2432 3.75708L3.75789 12.2424'
            stroke='currentColor'
            strokeLinecap='round'
            strokeWidth='1.25'
          />
        </svg>
      </button>
    </section>
  );
}
